// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NMqp","col":"styles_col__16-oc"};